import { motion } from "framer-motion";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaArrowUp } from "react-icons/fa";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative pt-28 pb-14 px-6 md:px-16 bg-neutral-background border-t border-neutral-border overflow-hidden">

      {/* Accent Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[900px] h-[420px] bg-accent/10 blur-[150px] rounded-full" />

      <div className="relative max-w-7xl mx-auto">

        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 text-center md:text-left">

          {/* BRAND */}
          <div className="space-y-6">

            {/* LOGO (UPDATED - NO CIRCLE) */}
            <div className="flex items-center justify-center md:justify-start">
              <img
                src={`${process.env.PUBLIC_URL}/assets/adminlogo.png`}
                alt="RCreate Logo"
                className="h-12 w-auto object-contain drop-shadow-md"
              />
            </div>

            <p className="text-sm text-neutral-muted max-w-sm mx-auto md:mx-0 leading-relaxed">
              Reliable virtual assistants helping founders streamline operations,
              strengthen marketing systems, and scale with clarity and confidence.
            </p>

            {/* Socials */}
            <div className="flex justify-center md:justify-start gap-4 pt-2">
              <motion.a
                href="https://www.linkedin.com/company/rcreate-virtual-assistance-services/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.15, y: -2 }}
                className="w-10 h-10 rounded-xl bg-white/60 backdrop-blur-xl border border-neutral-border flex items-center justify-center text-primary hover:text-accent transition shadow-sm hover:shadow-md"
              >
                <FaLinkedinIn size={14} />
              </motion.a>

              <motion.a
                href="https://www.facebook.com/rcreatevaservices"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.15, y: -2 }}
                className="w-10 h-10 rounded-xl bg-white/60 backdrop-blur-xl border border-neutral-border flex items-center justify-center text-primary hover:text-accent transition shadow-sm hover:shadow-md"
              >
                <FaFacebookF size={14} />
              </motion.a>

              <motion.a
                href="https://www.instagram.com/rcreatevaservices/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.15, y: -2 }}
                className="w-10 h-10 rounded-xl bg-white/60 backdrop-blur-xl border border-neutral-border flex items-center justify-center text-primary hover:text-accent transition shadow-sm hover:shadow-md"
              >
                <FaInstagram size={14} />
              </motion.a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="space-y-6">
            <h4 className="font-heading text-primary text-lg">
              Quick Links
            </h4>

            <div className="flex flex-col gap-3 text-sm text-neutral-muted">
              {[
                { name: "About", link: "#about" },
                { name: "Services", link: "#services" },
                { name: "Process", link: "#how-it-works" },
                { name: "Contact", link: "#contact" },
              ].map((item, i) => (
                <a
                  key={i}
                  href={item.link}
                  className="hover:text-accent transition hover:translate-x-1"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>

          {/* EXTRA (NEW SECTION - MAKES IT LOOK PREMIUM) */}
          <div className="space-y-6">
            <h4 className="font-heading text-primary text-lg">
              Get Started
            </h4>

            <p className="text-sm text-neutral-muted leading-relaxed">
              Ready to simplify your operations and scale your business with expert virtual support?
            </p>

            <motion.a
              href="#contact"
              whileHover={{ scale: 1.05 }}
              className="inline-block px-6 py-3 rounded-xl bg-accent text-white text-sm font-medium shadow-md hover:shadow-lg transition"
            >
              Book a Free Consultation
            </motion.a>
          </div>
        </div>

        {/* BOTTOM BAR */}
        <div className="mt-20 pt-6 border-t border-neutral-border flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-neutral-muted">

          <p className="text-center md:text-left">
            © {new Date().getFullYear()}{" "}
            <span className="font-semibold text-primary">
              RCREATE Virtual Assistance
            </span>
            . All rights reserved.
          </p>

          {/* Back to Top */}
          <motion.button
            onClick={scrollToTop}
            whileHover={{ y: -3 }}
            className="flex items-center gap-2 text-primary hover:text-accent transition"
          >
            Back to Top
            <FaArrowUp size={14} />
          </motion.button>
        </div>

      </div>
    </footer>
  );
}